<template>
  <div>
    <div id="subject-table">
      <table class="table table-hover ui-table mb-4 mt-2">
        <thead>
          <tr>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.main_program'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.sub_program'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.subject'
                )
              }}
            </th>
            <th style="width: 3%" class="text-center">
              <a href="#" @click.prevent="addNewRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(subject, index) in teacher_subject_list" :key="index">
            <td>
              <select
                class="form-control only-border-bottom"
                :class="{
                  'is-invalid': errors.has(
                    'teacher_subject_list.' + index + '.acp_id'
                  ),
                }"
                v-model="subject.acp_id"
                @change="onMainProgramChange(subject)"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(main_program, index) in main_programs"
                  :key="index"
                  :value="main_program.acp_id"
                >
                  {{ main_program.acp_name_foreign }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="errors.has('teacher_subject_list.' + index + '.acp_id')"
              >
                {{ errors.first('teacher_subject_list.' + index + '.acp_id') }}
              </div>
            </td>
            <td>
              <select
                class="form-control only-border-bottom"
                :class="{
                  'is-invalid': errors.has(
                    'teacher_subject_list.' + index + '.acps_id'
                  ),
                }"
                v-model="subject.acps_id"
                @change="onSubProgramChange(subject)"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(sub, index) in getSubPrograms(subject.acp_id)"
                  :key="index"
                  :value="sub.acps_id"
                >
                  {{ sub.acps_name_foreign }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="errors.has('teacher_subject_list.' + index + '.acps_id')"
              >
                {{ errors.first('teacher_subject_list.' + index + '.acps_id') }}
              </div>
            </td>
            <td>
              <select
                class="form-control only-border-bottom"
                :class="{
                  'is-invalid': errors.has(
                    'teacher_subject_list.' + index + '.subject_id'
                  ),
                }"
                v-model="subject.subject_id"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(subjectItem, index) in getSubject(subject.acps_id)"
                  :key="index"
                  :value="subjectItem.subject_id"
                >
                  {{ subjectItem.subject_name_foreign }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="
                  errors.has('teacher_subject_list.' + index + '.subject_id')
                "
              >
                {{
                  errors.first('teacher_subject_list.' + index + '.subject_id')
                }}
              </div>
            </td>
            <td>
              <a
                href="#"
                class="text-danger"
                @click.prevent="removeRow(subject)"
              >
                <i class="fa fa-trash mt-2"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapGetters } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'subject',
  props: ['value', 'validate'],
  data() {
    return {
      teacher_subject_list: [],
      subject_lists: {
        subject_id: '',
        acp_id: '',
        acps_id: '',
      },
      errors: new Errors(),
    }
  },
  created() {
    this.teacher_subject_list = this.value
  },
  computed: {
    ...mapState('teacherProfile', ['main_programs', 'edit_data']),
    ...mapGetters('teacherProfile', ['getSubPrograms', 'getSubject']),
  },
  methods: {
    addNewRow() {
      this.teacher_subject_list.push(Object.assign({}, this.subject_lists))
    },
    removeRow(subject) {
      this.teacher_subject_list.splice(
        this.teacher_subject_list.indexOf(subject),
        1
      )
    },
    async onMainProgramChange(subject) {
      if (!subject.acp_id) {
        subject.acps_id = ''
        subject.subject_id = ''
        return
      }
      await this.$store
        .dispatch('teacherProfile/subProgram', subject.acp_id)
        .then((response) => {})
        .catch((error) => {
          this.$toasted.error(error.message)
        })
    },
    async onSubProgramChange(subject) {
      if (!subject.acps_id) {
        subject.subject_id = ''
        return
      }
      await this.$store
        .dispatch('teacherProfile/subject', subject.acps_id)
        .then((response) => {})
        .catch((error) => {
          this.$toasted.error(error.message)
        })
    },
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true,
    },
    value: {
      handler() {
        this.teacher_subject_list = this.value
      },
    },
    edit_data: {
      handler() {
        if (!_.isEmpty(this.edit_data)) {
          this.edit_data.subjects.map(async (el) => {
            await this.onMainProgramChange(el)
            await this.onSubProgramChange(el)
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="css" scoped>
#subject-table {
  max-height: 20vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#subject-table::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
#subject-table::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
